import React from 'react'
import { connect } from 'react-redux'
import SalaryDepRatioDiv from './SalaryDepRatioDiv'
import {
	addListItem, changeListItem, deleteListItem, getListFromValues, getListItems,
	hasChangedValues, getFormValue, changeItemsValue, nullDate
} from 'tyan/public/utility'

class ResponsibleDepSetDiv extends React.Component {
	state = {
		bReadOnly: this.props.bReadOnly || false,
		id: this.props.id || 0,
	}

	componentDidMount = () => {
		this.doGetResponsibleDep()
	}

	doGetResponsibleDep = () => {
		const { id } = this.state
		Tyan.doPostEvent('GetResponsibleDep', {
			data: { id },
			onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
				}
			}
		})
	}

	handlerSave = () => {
		const { onClose, onRefresh, } = this.props
		const { id, changedValues基本信息 } = this.state
		Tyan.doPostEvent('SaveResponsibleDep', {
			data: { id, changedValues基本信息 },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					onRefresh && onRefresh()
					onClose && onClose()
				}
			}
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	canSave = () => {
		return this.bChanged()
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	fieldset基本信息 = () => {
		const { list } = getListItems(this, '基本信息', '角色信息')
		return [
			{
				_group: '', margin: 0, items: [
					{
						_group: '', name: 'title', minWidth: '95%', items: [
							{ _label: '角色', minWidth: 120, },
							{ _label: '负责部门', minWidth: 120, flex: 1 },
						]
					}
				].concat(list.map(o => {
					const _list = { id: o.id, listName: '角色信息' }
					return {
						_group: '', name: 'value', minWidth: '95%', list: _list, items: [
							{ _text: '', name: '角色', minWidth: 120, disabled: true, encloserLayout: { pack: 'end' } },
							{ _select: '', name: '负责部门', minWidth: 120, flex: 1, multiSelect: true },
						]
					}
				}))
			}
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, } = this.props
		const { errorMessage, id, initValues基本信息, bReadOnly } = this.state

		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />

		return <Body data={this} maxWidth="700"
			controls={
				bReadOnly && [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] ||
				[
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
				]}
		/>
	}
}

export default ResponsibleDepSetDiv